import React from "react";
import { useSelector } from "react-redux";
import Icon from "@mdi/react";
import { mdiCheck, mdiCalendarOutline, mdiMapMarkerOutline } from "@mdi/js";
import BookingHeader from "./BookingHeader";
import { formatDate, formatTime, getFirstNameInitial } from "../utils";

const BookingSuccess = () => {
  const { companyInfo, confirmResult, selectedTimezone } = useSelector(
    (state) => state.publicClientBooking
  );

  const appointment = confirmResult?.appointment;
  const address = confirmResult?.address;
  const inspector = confirmResult?.inspector;

  const addressLine1 = [address?.address_line1, address?.address_line2]
    .filter(Boolean)
    .join(", ");
  const addressLine2 = [address?.city, address?.state, address?.zip_code]
    .filter(Boolean)
    .join(", ");

  return (
    <div className="public-client-booking-container">
      <BookingHeader
        companyName={companyInfo?.name}
        companyLogo={companyInfo?.logo}
      />
      <main className="public-client-booking-outcome-main">
        {/* Success icon */}
        <div className="public-client-booking-success-icon-wrapper">
          <Icon path={mdiCheck} size={1.5} color="#fff" />
        </div>

        <h1 className="public-client-booking-outcome-title">
          Booking Confirmed!
        </h1>
        <p className="public-client-booking-outcome-subtitle">
          Your inspection has been scheduled and your inspector will contact you
          soon.
        </p>

        {/* Single card: date/address + inspector */}
        <div className="public-client-booking-success-card">
          {/* Date & Address row */}
          <div className="public-client-booking-success-summary-row">
            <div className="public-client-booking-success-summary-col">
              <div className="public-client-booking-success-summary-icon">
                <Icon path={mdiCalendarOutline} size="32px" />
              </div>
              <div>
                <div className="public-client-booking-success-summary-primary">
                  {formatDate(appointment?.start_time, selectedTimezone)}
                </div>
                <div className="public-client-booking-success-summary-secondary">
                  {appointment
                    ? `${formatTime(appointment.start_time, selectedTimezone)} - ${formatTime(appointment.end_time, selectedTimezone)}`
                    : ""}
                </div>
              </div>
            </div>

            <div className="public-client-booking-success-summary-col">
              <div className="public-client-booking-success-summary-icon">
                <Icon path={mdiMapMarkerOutline} size="32px" />
              </div>
              <div>
                <div className="public-client-booking-success-summary-primary">
                  {addressLine1}
                </div>
                <div className="public-client-booking-success-summary-secondary">
                  {addressLine2}
                </div>
              </div>
            </div>
          </div>

          {/* Inspector section */}
          {inspector && (
            <>
              <hr className="public-client-booking-success-card-divider" />
              <div className="public-client-booking-success-inspector-label">
                Your Inspector
              </div>
              <div className="public-client-booking-success-inspector-row">
                {inspector.profile_image_url ? (
                  <img
                    src={inspector.profile_image_url}
                    alt={inspector.name}
                    className="public-client-booking-success-inspector-avatar"
                  />
                ) : (
                  <div className="public-client-booking-success-inspector-initial">
                    {getFirstNameInitial(inspector.name)}
                  </div>
                )}
                <div>
                  <div className="public-client-booking-success-inspector-name">
                    {inspector.name}
                  </div>
                  <div className="public-client-booking-confirm-field-meta-row">
                    {inspector.phone && <span>{inspector.phone}</span>}
                    {inspector.email && <span>{inspector.email}</span>}
                  </div>
                  {inspector.license_number && (
                    <div className="public-client-booking-success-inspector-meta">
                      License Number: {inspector.license_number}
                    </div>
                  )}
                </div>
              </div>
            </>
          )}
        </div>
      </main>
    </div>
  );
};

export default BookingSuccess;
